// import Vue from 'vue'
// import isEqual from 'lodash.isequal'

import stateDefinition from './state'
import mutationsDefinition from './mutations'
import actionsDefinition from './actions/'
import gettersDefinition from './getters'

import extendConfig from './extendConfig'

export const registerServiceModule = (store, customConfig) => {
  let { config, common } = extendConfig(customConfig)
  // --- REGISTER STORE MODULE ---
  let moduleExists = !!store.state[config.name]
  let preserveState = moduleExists
  // if using hotreload: need to unregister if already present?
  let hotReload = window && window.webpackHotUpdate
  if (moduleExists && hotReload) {
    store.unregisterModule(config.name)
    preserveState = false
  }
  store.registerModule(config.name, {
    namespaced: true,
    state: stateDefinition({ config, common }),
    mutations: mutationsDefinition({ config, common }),
    actions: actionsDefinition({ config, common }),
    getters: gettersDefinition({ config, common })
  }, { preserveState: preserveState }) // do not overwrite state if it's rehydrated (relevant with SSR)
  // call auto-load hook upon login
  // setup authentication watcher, call reset upon logout
  if (store.state.authentication && store.state.authentication.authenticated !== undefined) {
    store.watch(() => store.state.authentication.authenticated, authenticated => {
      if (config.noAutoReset === false) {
        if (authenticated) {
          store.dispatch(`${config.name}/autoLoad`, { root: true })
        } else {
          store.commit(`${config.name}/reset`, { root: true })
        }
      }
    })
  }
}
